/* globals $ window */

(function() {
	'use strict';

	/**
	 * Checkout using Punchout
	 */
	var PunchOutCheckoutPage = function() {
		// Submit the cart form after 1 second
		window.setTimeout(this.submitForm, 1000);
	};

	PunchOutCheckoutPage.prototype = {
		submitForm: function() {
			$('#checkout_form').submit();
		}
	};
	
	C.PunchOutCheckoutPage = PunchOutCheckoutPage;

	class CheckoutPage {
		constructor(checkoutModules, shoppingCart, step, prevSubmittedStep, storeLocations) {
			var self = this;
			this.shoppingCart = shoppingCart;
			this.checkoutModules = checkoutModules;
			this.storeLocations = storeLocations;
			this.modules = [];
			if (this.checkoutModules) {
				for(var i = 0; i < this.checkoutModules.length; i++) {
					this.modules.push(new C.CheckoutModules[this.checkoutModules[i].name](this.shoppingCart));
				}
			}
			// Determine which modules have all the valid data they need
			var nextIncompleteStep = this.nextIncompleteStep();
			if(nextIncompleteStep !== null) {
				this.step = Math.min(step, nextIncompleteStep);
			}
			else {
				this.step = step;
			}
			$('#checkout_module_' + this.step).show();
			$('#step').val(this.step);
			let moduleSelector = '.checkout_module:not(#checkout_module_' + this.step + ')';
			$(moduleSelector + ' input,' + moduleSelector + ' select').attr('disabled', true);
			
			// Errors exist if the step has not changed
			if (this.step === prevSubmittedStep) {
				let flashError = 'There are errors that prevent you from continuing, see details below.';
				if (this.shoppingCart.errors.credit_card) {
					flashError = this.shoppingCart.errors.credit_card;
				}
				$('#header').append('<div class="alert alert-danger">'+flashError+'</div>');
			}
			
			this.initCreditCard();
			
			this.initCartPreview();
			this.createVerticalRule();
			
			$('#store_location').on('change', function() {
				self.handleStoreLocation();
			});
			this.handleStoreLocation();
			
			$('#same_as_shipping').on('change', function() {
				self.toggleBillingFields();
			});
			this.toggleBillingFields();
			
			$('#payment_methods input').on('change', function() {
				self.togglePaymentMethodFields();
			});
			this.togglePaymentMethodFields();
			
			this.initBreadcrumbs();
			
			$('.previous').attr('href', $('.previous').attr('href') + '?step=' + (this.step - 1));
			var previousModuleName = $('#breadcrumbs .breadcrumb-link[data-step="'+(this.step-1)+'"]').text();
			$('.previous').text($('.previous').text() + ' to ' + previousModuleName);
			if (this.step == this.checkoutModules.length - 1) {
				$('.continue').text('Checkout');
			}
			
			$('#cvv-help').tooltip({
				animated: 'fade',
				html: true
			});
			
			$('.checkout-form').on('submit', function() {
				if ($('.checkout-form #shopping_cart_email').is(':visible')) {
					$('.checkout-form #shopping_cart_email').prop('disabled', false);
				}
			});
			
			this.initTooltips();
			
		}
		
		initCreditCard() {
			if ($('#credit_card_fields').length && $('.payment_method_fields').is(':visible')) {
				var form = $('.checkout-form');
				var formElem = form.get(0);
				var creditCardForm = new Plastic.CreditCardForm(formElem);
				form.on('submit', function(evt) {
					if ($('#payment_methods input[type=radio]:checked').val() == 'credit_card') {
						evt.preventDefault(); // Don't submit the form right now
						// Validate the form here and return if invalid
						var numberValid = creditCardForm.isValid();
						if(!numberValid) {
							alert("Credit card number is not valid");
							return;
						}
						creditCardForm.tokenizeCard(function(err, success) {
							//if(err) return alert('tokenize failed: ' + err.type);
							// Successful
							formElem.submit();
						});
					}
				});
			}
		}
		
		// Disble breadcrumb links for incomplete steps
		initBreadcrumbs() {
			var self = this;
			$('#breadcrumbs .breadcrumb-link').each(function() {
				var breadcrumbStep = parseInt($(this).data('step'));
				if (breadcrumbStep > self.step)
				 	$(this).addClass('disabled');
				else if (breadcrumbStep == self.step)
					$(this).addClass('current');
			});
		}
		
		initCartPreview() {
			var self = this;
			this.bsEnv = this.findBootstrapEnvironment();
			if (this.bsEnv == 'xs' || this.bsEnv == 'sm') {
				self.toggleCartPreview(false, 'hide');
			}
			
			$('#cartPreviewToggle').on('click', function() {
				self.toggleCartPreview(true, ($('.shopping-cart-preview').is(':visible') ? 'hide' : 'show'));
			});
			
			$(window).resize(function() {
				self.adjustCartPreview(self.findBootstrapEnvironment());
			});
		}
		
		initTooltips() {
			$('.checkout-form input, .checkout-form select').each(function() {
				$(this).tooltip({
					title: $(this).data('error-message')
				});
			});
			
			$('.checkout-form input, .checkout-form select').on('input', function() {
				$(this).parent().removeClass('has-error');
				$(this).tooltip('hide');
				$(this).tooltip('disable');
			});
		}
		
		// Vertical rule down the middle of the page
		createVerticalRule() {
			var leftHeight = $('.checkout .left').outerHeight();
			var rightHeight = $('.checkout .right').outerHeight();
			var borderStyle = '1px solid #e7e7e7';
			if (leftHeight > rightHeight) {
				$('.checkout .left').css('border-right', borderStyle);
			} else {
				$('.checkout .right').css('border-left', borderStyle);
			}
		}
		
		adjustCartPreview(newEnv) {
			if (this.bsEnv != newEnv) {
				var largeEnvs = ['md', 'lg'];
				var smallEnvs = ['xs', 'sm'];
				if (smallEnvs.indexOf(newEnv) >= 0 && largeEnvs.indexOf(this.bsEnv) >= 0) {
					// Window shrunk from md to sm
					this.toggleCartPreview(false, 'hide');
				} else if (largeEnvs.indexOf(newEnv) >= 0 && smallEnvs.indexOf(this.bsEnv) >= 0) {
					// Window expanded from sm to md
					this.toggleCartPreview(false, 'show');
				}
				this.bsEnv = newEnv;
			}
		}
		
		toggleCartPreview(clicked, action) {
			if (clicked) {
				$('.shopping-cart-preview').slideToggle();
			} else if (action == 'hide') {
				$('.shopping-cart-preview').hide();
			} else {
				$('.shopping-cart-preview').show();
			}
			
			$('.collapsed-preview-total').toggle(action == 'hide' ? true : false);
			$('#cartPreviewToggle .action').text(action == 'hide' ? 'show' : 'hide');
		}
		
		handleStoreLocation() {
			let selectedAddressId = $('#store_location').val();
			let selectedAddress = null;
			
			// Get the selected store location
			for (let i = 0; i < this.storeLocations.length; i++) {
				if (this.storeLocations[i].id == selectedAddressId) {
					selectedAddress = this.storeLocations[i];
					break;
				}
			}
			
			// Set hidden fields for shipping address based on the selected store location
			let hiddenFields = ['street1', 'street2', 'city', 'state', 'postal_code', 'country', 'email', 'phone', 'original_address_id', 'deliver_to1'];
			for (let i = 0; i < hiddenFields.length; i++) {
				let val = '';
				if (selectedAddress != null) {
					val = selectedAddress[hiddenFields[i]];
					if (hiddenFields[i] == 'original_address_id') {
						val = selectedAddress.id;
					}
					if (hiddenFields[i] == 'deliver_to1') {
						// HACK: Copy store address name to deliver_to1 because deliver_to1 is required for all checkout addresses.
						val = selectedAddress.name;
					}
				}
				$('.store_location input[name=shopping_cart\\[shipping_address_attributes\\]\\['+hiddenFields[i]+'\\]]').val(val);
			}
			
			this.toggleStoreLocation();
		}
		
		toggleStoreLocation() {
			let selectedAddressId = $('#store_location').val();
			$('.store-location').hide();
			$('.store-location-'+selectedAddressId).show();
		}
		
		togglePaymentMethodFields() {
			$('.payment_method_fields').hide();
			$('#' + $('#payment_methods input:checked').val() + '_fields').show();
		}
		
		toggleBillingFields() {
			$('#billing_address_fields').toggle(!$('#same_as_shipping').is(':checked'));
			$('#same_as_shipping_hidden').val($('#same_as_shipping').is(':checked') ? '1' : '0');
		}
		
		findBootstrapEnvironment() {
			var envs = ['xs', 'sm', 'md', 'lg'];
			
			var el = $('<div>');
			el.appendTo($('body'));
			
			for (var i = envs.length - 1; i >= 0; i--) {
				var env = envs[i];
				
				el.addClass('hidden-'+env);
				if (el.is(':hidden')) {
					el.remove();
					return env;
				}
			}
		}

		// Find the first step that is not complete (has invalid/missing data)
		nextIncompleteStep() {
			for(var i = 0; i < this.modules.length; i++) {
				if(!this.modules[i].complete()) {
					return i;
				}
			}
			// All steps are complete
			return null;
		}
	}
	
	C.CheckoutPage = CheckoutPage;

	// Base Class for checkout modules
	class CheckoutModule {
		constructor(shoppingCart) {
			this.shoppingCart = shoppingCart;
		}

		// Return true if all data needed for this step is complete
		complete() {
			throw new Error("complete must be overridden by the subclass");
		}

	}

	class ShippingAddressModule extends CheckoutModule {
		complete() {
			let cart = this.shoppingCart;
			if(cart.shipping_address_id === null || cart.shipping_address === null) {
				return false;
			}
			if(cart.errors) {
				for(var x in cart.errors) {
					if(x.indexOf('shipping_address') === 0 || x === 'email') {
						return false;
					}
				}
			}
			return true;
		}
	}

	class PaymentModule extends CheckoutModule {
		complete() {
			let cart = this.shoppingCart;
			if(!cart.payment_method) {
				return false;
			}
			if(cart.errors) {
				for(var x in cart.errors) {
					if(x.indexOf('billing_address') === 0 || x === 'po_number' || x.indexOf('credit_card') === 0) {
						return false;
					}
				}
			}
			return true;
		}
	}
	
	class StoreLocationModule extends CheckoutModule {
		complete() {
			let cart = this.shoppingCart;
			if(cart.shipping_address_id === null || cart.shipping_address === null) {
				return false;
			}
			if(cart.errors) {
				for(var x in cart.errors) {
					if(x.indexOf('shipping_address') === 0 || x === 'email') {
						return false;
					}
				}
			}
			return true;
		}
	}

	C.CheckoutModules = {
		'shipping_address': ShippingAddressModule,
		'payment': PaymentModule,
		'store_location': StoreLocationModule
	};

})();
